export class FoodFulfillmentConfigApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * Step 1 of four-eyes (D350): submit a candidate version for approval. Requires `fulfillment:propose`. The author is
     * the authenticated caller. The candidate is stored PENDING_APPROVAL and is **not live** until a SECOND
     * operator calls `approveVersion`. A malformed body is 400; a version already pending or already published
     * is 409.
     */
    submitVersion(policyId, input) {
        return this.client.request({ method: 'POST', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/versions`, body: input, auth: true });
    }
    /**
     * Step 2 of four-eyes (D350): approve a pending candidate, which publishes and activates it. Requires
     * `fulfillment:approve` AND an approver who is not the author — a self-approval is 403. The server runs the
     * no-illegal-loosening guard + monotonic-version guard (409). An approval is single-use: a replay is 409.
     */
    approveVersion(policyId, version, approvalReason) {
        return this.client.request({ method: 'POST', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/versions/${version}/approve`, body: { approvalReason }, auth: true });
    }
    /**
     * Reject a pending candidate with a reason (requires `fulfillment:approve`). The proposal stays on the governance
     * record as REJECTED and the version number is freed for a corrected re-submission.
     */
    rejectVersion(policyId, version, reason) {
        return this.client.request({ method: 'POST', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/versions/${version}/reject`, body: { reason }, auth: true });
    }
    /** The checker's queue: candidates awaiting approval for a policy, oldest submission first. */
    listPending(policyId) {
        return this.client.request({ method: 'GET', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/pending`, auth: true });
    }
    /**
     * Roll the live pointer back to a prior published version; the target must exist (404 otherwise). The reason is
     * required and recorded with the operator who moved the pointer (D350).
     */
    rollback(policyId, toVersion, reason) {
        return this.client.request({ method: 'POST', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/rollback`, body: { toVersion, reason }, auth: true });
    }
    /** The currently-active published version for a policy (404 when nothing is live). */
    getActive(policyId) {
        return this.client.request({ method: 'GET', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/active`, auth: true });
    }
    /** The full published version history for a policy, ascending by version. */
    listVersions(policyId) {
        return this.client.request({ method: 'GET', path: `/v1/food-fulfillment-config/policies/${encodeURIComponent(policyId)}/versions`, auth: true });
    }
}
//# sourceMappingURL=food-fulfillment-config.js.map